import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateManager } from 'src/app/core/managers/date.manager';
import { ExtraDocument } from 'src/app/core/interfaces/extraDocument';
import { AdditionalCertificationDict, AdditionalCertificationEnum } from 'src/app/core/enums/additionalCertification.enum';
@Component({
  selector: 'app-docs-state',
  templateUrl: './docs-state.component.html',
  styleUrls: ['./docs-state.component.scss'],
  providers: [DatePipe]
})
export class DocsStateComponent implements OnInit {
  // INPUTS
  @Input() expireDocs: boolean = false;
  @Input() documents: ExtraDocument[] = [];
  @Input() type: 'ARL' | 'EPS' | AdditionalCertificationEnum;
  @Input() userState: boolean = false;
  @Input() dueDateDoc: string = '';
  @Input() typesRules: string[] = null;
  statusDocs: string = '';
  isOptionalDocument: boolean = false;
  constructor(
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.updateDocumentState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.expireDocs || changes.documents || changes.user || changes.typesRules) this.updateDocumentState();
  }

  updateDocumentState(): void {
    this.statusDocs = this.calculateStatus();
  }

  calculateStatus(): string {
    let matchDoc: ExtraDocument;
    matchDoc = (this.documents).find(doc => doc && (doc.type === this.type || doc.type.toLowerCase() === this.type.toLowerCase()));
    this.isOptionalDocument = this.typesRules && !this.typesRules.includes(this.type.toLowerCase());
    return matchDoc && matchDoc['approvalBy'] ?
      this.expireDocs ?
        (this.userState && !this.dueDateDoc) || this.isOptionalDocument ?
          'optional' :
          'required' :
        'current' :
      'pending';
  }

  formatStringToDate(date: string): string {
    return this.datePipe.transform(DateManager.stringToDate(date), "d MMMM yyyy");
  }

  // GETTERS
  getTooltipClass(status: string): string {
    switch (status) {
      case 'current': return 'custom-tooltip success-tooltip';
      case 'optional': return 'custom-tooltip info-tooltip';
      case 'required': return 'custom-tooltip error-tooltip';
      case 'pending': return 'custom-tooltip warning-tooltip';
      default: return '';
    }
  }

  getDocumentState(): string {
    const realType = this.type === 'ARL' || this.type === 'EPS' ? this.type : AdditionalCertificationDict[this.type];
    let message = `El documento cargado de la ${realType} está `;
    switch (this.statusDocs) {
      case 'current': message += 'vigente'; break;
      case 'optional': message += 'vencido (el cargue del documento es opcional)'; break;
      case 'required': message += 'vencido (el cargue del documento es obligatorio)'; break;
      case 'pending': message = 'El documento cargado está pendiente por aprobación'; break;
      default: message = ''; break;
    }
    let matchDoc: ExtraDocument;
    matchDoc = (this.documents).find(doc => doc && doc.type === this.type);
    if (matchDoc && matchDoc['dueDate']) {
      message += this.statusDocs !== 'pending' ? `.\n Fecha de vencimiento: ${this.formatStringToDate(matchDoc['dueDate'])}` : '';
    }
    return message;
  }

  getDocumentSupport(type: 'ARL' | 'EPS' | AdditionalCertificationEnum, documents: ExtraDocument[]): boolean {
    return documents && documents.length && documents.some(document => document && document.type === type);
  }

}
